export var ESendFeedbackActionType = /*#__PURE__*/function (ESendFeedbackActionType) {
  ESendFeedbackActionType["SendFeedbackSucceed"] = "sendFeedback/setStatus/succeed";
  ESendFeedbackActionType["SendFeedbackFailed"] = "sendFeedback/setStatus/failed";
  ESendFeedbackActionType["SendFeedbackInitial"] = "sendFeedback/setStatus/initial";
  return ESendFeedbackActionType;
}({});